import { render, staticRenderFns } from "./candidats.vue?vue&type=template&id=42ccdc68"
import script from "./candidats.vue?vue&type=script&lang=js"
export * from "./candidats.vue?vue&type=script&lang=js"
import style0 from "./candidats.vue?vue&type=style&index=0&id=42ccdc68&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderCandidats: require('/home/etienne/AM-frontend/components/HeaderCandidats.vue').default,ErrorFieldHandler: require('/home/etienne/AM-frontend/components/ErrorFieldHandler.vue').default,FormErrorPopUp: require('/home/etienne/AM-frontend/components/FormErrorPopUp.vue').default})
